import { render } from "./Header_en.vue?vue&type=template&id=de80fa12"
import script from "./Header_en.vue?vue&type=script&lang=js"
export * from "./Header_en.vue?vue&type=script&lang=js"

import "./Header_en.vue?vue&type=style&index=0&id=de80fa12&lang=css"
script.render = render

export default script